import { useIntl } from 'react-intl';

import { PrizeDumb } from '@sorare/core/src/components/landing/PrizesBlock/PrizeDumb';
import { messages } from '@sorare/core/src/components/landing/PrizesBlock/messages';

import rewardCashImage from './assets/RewardCashImage.jpg';

type Props = {
  isHovered?: boolean;
};

export const CashRewardMLB = ({ isHovered }: Props) => {
  const { formatMessage } = useIntl();
  return (
    <PrizeDumb
      title={formatMessage({
        id: 'Landing.Prizes.cashRewardMLB',
        defaultMessage: 'Cash Rewards Available in Sorare: MLB',
      })}
      subtitle={formatMessage({
        id: 'Landing.Prizes.cashRewardMLBSub',
        defaultMessage: 'Cash Rewards',
      })}
      cta={formatMessage(messages.learnCTA)}
      bgImage={rewardCashImage}
      isHovered={isHovered}
      flexBasis="33.33%"
      link="https://sorare.com/help/a/15119711065885/what-rewards-or-prizes-can-i-win-in-sorare-mlb"
    />
  );
};
